import {Component, OnInit} from '@angular/core';
import {IMyDateModel} from 'mydatepicker';

@Component({
    selector: 'statistic-repartition',
    templateUrl: './templates/statistic-repartition.component.html',
    styleUrls: ['./styles/bootstrap.css', './styles/statistic-repartition.component.css']
})
export class StatisticRepartitionComponent implements OnInit {

    date_from: any;
    date_to: any;

    category_list: Array<any> = [
        {id_category: 'steak-0', name: 'Steak'},
        {id_category: 'pizza-1', name: 'Pizza'},
        {id_category: 'tacos-2', name: 'Tacos'}
    ];

    public lineChartData: Array<any> = [
        [65, 59, 80, 81, 56, 55, 40],
        [28, 48, 40, 19, 86, 27, 90]
    ];
    public lineChartLabels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    public lineChartType: string = 'line';
    public pieChartType: string = 'pie';

    // Pie
    public pieChartLabels: string[] = ['Download Sales', 'In-Store Sales', 'Mail Sales'];
    public pieChartData: number[] = [300, 500, 100];

    constructor() {}

    ngOnInit() {
    }

    onDate1Changed(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date_from = "";
        } else {
            this.date_from = event.jsdate.toLocaleDateString("en-US");
        }
    }
    onDate2Changed(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date_to = "";
        } else {
            this.date_to = event.jsdate.toLocaleDateString("en-US");
        }
    }

    public randomizeType(): void {
        this.lineChartType = this.lineChartType === 'line' ? 'bar' : 'line';
        this.pieChartType = this.pieChartType === 'doughnut' ? 'pie' : 'doughnut';
    }

    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }
}



// WEBPACK FOOTER //
// ./src/app/statistic-repartition.component.ts